var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { getRootLogger } from '@lucidlink/tscore';
import { useLucidSdk } from '#context';
export const useSsoRegister = ({ onError, onSuccess, }) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const mutation = useMutation({
        mutationFn: async ({ loginEmail, ...params }) => lucidSdk.authenticationClient().ssoRegisterUser(params),
        onSuccess: (_, params) => {
            getRootLogger().info({ email: params.loginEmail }, 'Sso registration succeeded');
            if (typeof onSuccess === 'function') {
                onSuccess(params);
            }
        },
        onError: (e, { loginEmail: email }) => {
            if (typeof onError === 'function') {
                onError(e);
            }
            getRootLogger().error({ err: e, email }, 'Sso registration failed');
        },
    });
    return mutation;
};
_react_refresh_temp_1(useSsoRegister, "BQaElb9uT0+pguh7S8aDatOYRp8=", false, () => [useLucidSdk, useMutation]);
